//@ts-check
import {Button} from '@/components-v2/atoms/Button/Button'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {convertUTCToLocal} from '@/utility/dateHelper'
import {useMemo} from 'react'
import {useProductReview} from '../../context/ProductReviewContext'
import {validateProductReviewTab} from '../utils/productReviewValidation'

export const ProductReviewActions = () => {
  const {isEditMode, setIsEditMode, resetEditableData, saveEditableData, isSaving, productData, selectedTabIndex} =
    useProductReview()
  const languages = useFeatureFlagLanguages()

  const updatedDateTime = /** @type {{updatedDateTime?: string}|undefined} */ (productData)?.updatedDateTime

  const validationErrors = useMemo(
    () => validateProductReviewTab(selectedTabIndex, productData, languages),
    [selectedTabIndex, productData, languages]
  )
  const hasValidationErrors = Object.keys(validationErrors).length > 0

  const handleCancelClick = () => {
    setIsEditMode(false)
    resetEditableData()
  }

  const handleSaveClick = async () => {
    try {
      await saveEditableData()
      setIsEditMode(false)
    } catch (error) {
      void error
    }
  }

  return (
    <div className="flex items-center justify-between gap-3 bg-[var(--color-background-layer-01)] p-4 mt-4 sticky bottom-0 top-0 z-[1000]">
      {!isEditMode ? (
        <>
          <div>Last updated: {convertUTCToLocal(updatedDateTime) || '-'}</div>
          <Button
            text="Edit"
            size="medium"
            variant="secondary"
            iconLeading="edit"
            onClick={() => setIsEditMode(true)}
          />
        </>
      ) : (
        <>
          <div>Editing</div>
          <div className="flex items-center gap-3">
            <Button text="Cancel" size="medium" variant="secondary" iconLeading="close" onClick={handleCancelClick} />
            <Button
              text="Save"
              size="medium"
              variant="primary"
              iconLeading="check"
              isLoading={isSaving}
              loadingText="Saving"
              disabled={hasValidationErrors}
              onClick={handleSaveClick}
            />
          </div>
        </>
      )}
    </div>
  )
}
